
import SectionDivisor from "./SectionDivisor.vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import {
  computed,
  ComputedRef,
  defineComponent,
  onBeforeMount,
  onMounted
} from "vue";
import { useStore } from "vuex";
import { Course } from "../../../../domain/entities/entities";
import { RepositoryException } from "../../../../domain/exceptions/exceptions";
import { dispatchErrorBox } from "../mixins";
import Card from "./Card.vue";

export default defineComponent({
  components: {
    Carousel,
    Slide,
    Navigation,
    Card,
    SectionDivisor
  },
  setup() {
    const store = useStore();

    let isPaused = true;

    onMounted(() => {
      document.addEventListener("scroll", iframeSettings);
    });

    onBeforeMount(async () => {
      await loadNewsCourses();
    });

    const iframeSettings = () => {
      const landingPage = document.getElementById(
        "landingPage"
      ) as HTMLDivElement;

      /** View port information */
      const { height } = landingPage.getBoundingClientRect();

      /** Iframe information */
      const iframe = document.querySelector(
        "[data-iframe]"
      ) as HTMLIFrameElement;
      const { y } = iframe.getBoundingClientRect();
      const iframeCenterPosition = y + iframe.offsetHeight / 2;
      const runningArea = !(
        iframeCenterPosition < 0 || iframeCenterPosition > height
      );

      if (!isPaused && !runningArea) {
        isPaused = true;
        pauseVideo(iframe);
      } else if (isPaused && runningArea) {
        playVideo(iframe);
        isPaused = false;
      }
    };

    const playVideo = (iframe: HTMLIFrameElement) => {
      if (iframe && iframe.contentWindow)
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"' + "playVideo" + '","args":""}',
          "*"
        );
    };

    const pauseVideo = (iframe: HTMLIFrameElement) => {
      if (iframe && iframe.contentWindow)
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"' + "stopVideo" + '","args":""}',
          "*"
        );
    };

    const newsCourses: ComputedRef<Course[]> = computed(() => {
      return store.getters["course_module/newCourses"] || [];
    });

    const settings = {
      itemsToShow: 1,
      transition: 1000
    };

    const breakpoints = {
      0: {
        itemsToShow: 1,
        snapAlign: "center"
      },

      280: {
        itemsToShow: 1,
        snapAlign: "center"
      },

      520: {
        itemsToShow: 2,
        snapAlign: "center",
        itemsToScroll: 2
      },

      980: {
        itemsToShow: 3,
        snapAlign: "center",
        itemsToScroll: 3
      },

      1030: {
        itemsToShow: 3,
        snapAlign: "center",
        itemsToScroll: 3
      },

      1580: {
        itemsToShow: 4,
        snapAlign: "center",
        itemsToScroll: 4
      }
    };

    function formattedDuration(duration: number) {
      const sec = duration;
      let hours: string | number = Math.floor(sec / 3600);
      let minutes: string | number = Math.floor((sec - hours * 3600) / 60);
      let seconds: string | number = sec - hours * 3600 - minutes * 60;
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      if (hours > 24) {
        return hours + "h";
      }
      if (hours == 0) {
        return minutes + ":" + seconds + "m";
      }
      return hours + ":" + minutes + ":" + seconds + "h";
    }

    async function loadNewsCourses(): Promise<void> {
      try {
        await store.dispatch("course_module/loadNewsCourses");
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    }
    return {
      newsCourses,
      breakpoints,
      settings,
      formattedDuration
    };
  }
});
